import {Component, OnInit} from '@angular/core';
import {Aktivitet} from './models/aktivitet';
import {AktiviteterService} from './aktiviteter.service';
import {ActivatedRoute, ParamMap} from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {Deltagare} from './models/deltagare';
import {Broderkort} from './models/broderkort';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {TilldelningComponent} from './tilldelning.component';
import {DialogService} from 'ng2-bootstrap-modal';
import {Forlaning, Hclistitem, Pricklistitem} from './models/hc';
import {isNull, isUndefined} from 'util';
import {Grej} from './models/grej';
import {Bestallning} from './models/bestallning';


const timings = 2000;

@Component({
    selector: 'app-aktivitet',
    templateUrl: './aktivitet.component.html',
    styles: ['tr.old td { color:gray; }'],
    animations: [
        trigger('broderkortState', [
            state('in', style({transform: 'translateX(0)'})),
            transition('void => *', [
                style({transform: 'translateY(100%)'}),
                animate(timings)
            ]),
            transition('* => void', [
                animate(timings, style({transform: 'translateY(100%)'}))
            ])
        ]),
        trigger('overviewState', [
            state('in', style({transform: 'translateX(0)'})),
            transition('void => *', [
                style({transform: 'translateY(-100%)'}),
                animate(timings)
            ]),
            transition('* => void', [
                animate(timings, style({transform: 'translateY(-100%)'}))
            ])
        ])
    ]
})
export class AktivitetDetailComponent implements OnInit {
    aktivitet: Aktivitet;
    selectedBroder: Deltagare;
    activeIndex: number;
    activeStatusPercent: number;
    broderkort: {};
    aktivFlik = 'översikt';
    sammanstallning: Grej[];
    bestallningar: Bestallning;
    hclista: Hclistitem[];
    pricklista: Pricklistitem[];

    constructor(private aktiviteterService: AktiviteterService, private route: ActivatedRoute, private dialogService: DialogService) {
        this.broderkort = {};
    }

    ngOnInit(): void {
        this.route.paramMap.switchMap((params: ParamMap) => this.aktiviteterService.getAktivitet(+params.get('aktiviteter_id')))
            .subscribe((a => {
                localStorage.setItem('Aktivitetsdatum', a.date);
                return this.aktivitet = a;
            }));
    }

    selectDeltagare(index: number) {
        this.selectedBroder = this.aktivitet.deltagare[index];
        this.activeIndex = index;
        this.activeStatusPercent = Math.ceil(100 * this.activeIndex / this.aktivitet.deltagare.length);
        const broder_id = this.selectedBroder.id;
        if (!this.broderkort[broder_id]) {
            this.aktiviteterService.getBroderkort(broder_id).then(result => this.showBroderkort(result));
        }
    }

    getSammanstallning() {
        this.aktiviteterService.getSammanstallning(this.aktivitet.id).then(result => this.sammanstallning = result);
    }

    getBestallningar() {
        this.aktiviteterService.getBestallningar(this.aktivitet.id).then(result => this.bestallningar = result);
    }

    getHclista() {
        this.aktiviteterService.getHclista(this.aktivitet.id).then(result => this.hclista = result);
    }

    getPricklista() {
        this.aktiviteterService.getPricklista(this.aktivitet.id).then(result => this.pricklista = result);
    }

    showBroderkort(broderkort: Broderkort) {
        this.broderkort[broderkort.id] = broderkort;
    }

    nextBroder() {
        if (this.activeIndex < this.aktivitet.deltagare.length - 1) {
            this.selectDeltagare(this.activeIndex + 1);
        }
    }

    prevBroder() {
        if (this.activeIndex > 0) {
            this.selectDeltagare(this.activeIndex - 1);
        }
    }

    showTilldelning() {
        this.dialogService.addDialog(TilldelningComponent, {
            broderkort: this.broderkort[this.selectedBroder.id],
            redan_tilldelat: this.aktivitet.deltagare[this.activeIndex].hc
        }, {closeByClickingOutside: true, backdropColor: 'rgba(0, 0, 0, 0.5)'})
            .subscribe((hc) => {
                this.tilldela(hc);
            });
    }

    tabort(index: number): void {
        if (confirm('Vill du ta bort tilldelningen?')) {
            const listan: Forlaning[] = this.selectedBroder.hc;
            listan.splice(index, 1);
            this.aktiviteterService.setHc(this.aktivitet.id, this.selectedBroder.id, listan)
                .then(result => this.selectedBroder.hc = result);
        }
    }

    tilldela(hc: Forlaning) {
        if (isUndefined(hc)) {
            return;
        }
        if (!this.selectedBroder.hc) {
            this.selectedBroder.hc = [];
        }

        const listan: Forlaning[] = this.selectedBroder.hc;
        listan.push(hc);
        this.aktiviteterService.setHc(this.aktivitet.id, this.selectedBroder.id, listan)
            .then(result => this.selectedBroder.hc = result);
    }

    setNothing() {
        this.aktiviteterService.setHc(this.aktivitet.id, this.selectedBroder.id, [])
            .then(result => this.selectedBroder.hc = result);

    }

    setNull() {
        if (confirm('Vill rensa alla val för denna broder?')) {
            this.aktiviteterService.unsetHc(this.aktivitet.id, this.selectedBroder.id)
                .then(result => this.selectedBroder.hc = result);
        }
    }

    trcolor(hc: Forlaning[]): string {
        if (isNull(hc)) {
            return 'warning';
        }
        if (hc.length === 0) {
            return 'old';
        }
    }

    list(hc: Forlaning[]) {
        if (isNull(hc)) {
            return '';
        }
        if (hc.length === 0) {
            return '--';
        }
        const res = [];
        for (const item of hc) {
            res.push((item.hc) ? item.short + ' hc' : item.short);
        }
        return res.join(', ');
    }

    showSammanstallning() {
        this.aktivFlik = 'sammanställning';
        this.getSammanstallning();
    }

    showHclista() {
        this.aktivFlik = 'HC-lista';
        this.getHclista();
    }

    showPricklista() {
        this.aktivFlik = 'Pricklista';
        this.getPricklista();
    }

    showBestallningar() {
        this.aktivFlik = 'Beställningar';
        this.getBestallningar();
    }

    showDeltagare() {
        this.aktivFlik = 'översikt';
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/aktivitet.component.ts